import { XMarkIcon } from "@heroicons/react/24/outline";
import { Button, HStack, Icon, Text, useMediaQuery } from "@chakra-ui/react";

import { BankCardIcon, SbpIcon } from "../../../icons";

interface Props {
  title: string;
  isSbp?: boolean;
  onClick: () => void;
}

export function AddCardInnerButton({ title, isSbp = false, onClick }: Props) {
  const [isSmallScreen] = useMediaQuery("(max-width: 330px)");

  return (
    <Button
      h="60px"
      pr="21px"
      justifyContent="space-between"
      onClick={onClick}
      backgroundColor="gray.75"
    >
      <HStack spacing={0}>
        <Icon as={BankCardIcon} boxSize="24px" color="purple.500" mr={isSmallScreen ? "8px" : "16px"} />
        <Text variant="brand" lineHeight="20px" letterSpacing="3%">{title}</Text>

        {isSbp && <Icon as={SbpIcon} w="14px" h="17px" ml="4px" />}
      </HStack>

      <Icon as={XMarkIcon} boxSize="24px" color="purple.500" transform="rotate(45deg)" />
    </Button>
  );
}
